<template>
  <search-custom-dropdown
    v-model="searchInput.moreBtn.state"
    :search-input-text="searchInput.moreBtn.text"
    :is-filled="displayFilterText()? true : false"
    :width="50"
  >
    <template v-slot:drop-content>
      <keyword-input
        :initial-keywords="lastNewQuery.query.Keywords"
        @update-keyword="updateKeyword"
      />
      <range-input-dropdown
        :initial-value="lastNewQuery.query.SqFt"
        :dropdown-options="areaOptions"
        :select-params="areaParams"
        @update-value="updateArea"
      />
    </template>
  </search-custom-dropdown>
</template>

<script>
import searchLayoutHandler from '../../mixins/searchLayoutHandler'
import { mapState } from 'vuex'

export default {
  mixins: [searchLayoutHandler],

  computed: {
    ...mapState('home', ['windowWidth'])
  },

  methods: {
    addToFilter(value) {
      return this.searchObject.searchResult && this.windowWidth < value
    },

    updateFilterSelection(selectedOptions, type) {
      this.newSearchQuery[type] = [...selectedOptions]
      this.displayFilterText()
    }
  }
}
</script>

<style scoped lang='sass'>
.number-selector
  cursor: pointer
  border-radius: 0.5rem
  border: 0.1rem solid transparent
  &.selected
    border: 0.1rem solid $hwayzBlack
</style>
